import { __extends, __spreadArrays } from "tslib";
import * as superagent from 'superagent';
import { composeAsync } from 'grey-group-function';
var ServiceAgentError = /** @class */ (function (_super) {
    __extends(ServiceAgentError, _super);
    function ServiceAgentError(info, message) {
        var _this = _super.call(this, message) || this;
        _this.info = info;
        return _this;
    }
    return ServiceAgentError;
}(Error));
export { ServiceAgentError };
var ServiceAgent = /** @class */ (function () {
    /**
     * 构造函数
     * @param domain 请求网关
     * @param reqFs 请求前函数组
     * @param resFs 请求后函数组
     */
    function ServiceAgent(domain, reqFs, resFs) {
        if (domain === void 0) { domain = '/'; }
        if (reqFs === void 0) { reqFs = []; }
        if (resFs === void 0) { resFs = []; }
        /** 请求前函数组 */
        this.reqFs = [];
        /** 请求后函数组 */
        this.resFs = [];
        this.domain = domain;
        this.reqFs = reqFs;
        this.resFs = resFs;
        this.create = this.create.bind(this);
        this.call = this.call.bind(this);
        this.get = this.get.bind(this);
        this.post = this.post.bind(this);
        this.put = this.put.bind(this);
        this.del = this.del.bind(this);
        this.send = this.send.bind(this);
    }
    /**
     * 向服务区发送请求
     * @param sar superagent
     * @param fus 处理函数
     * @param reqFs 请求前函数组
     * @param resFs 请求后函数组
     */
    ServiceAgent.prototype.send = function (option) {
        var target = option.target;
        var sar = option.sar;
        var reqFs = option.reqFs || this.reqFs;
        var resFs = option.resFs || this.resFs;
        var fus = option.fus || [];
        return composeAsync.apply(null, __spreadArrays(reqFs, [request], resFs, fus))({ target: target, sar: sar });
    };
    /** 创建并发送一个请求 */
    ServiceAgent.prototype.create = function (type, url, params, domain) {
        if (domain === void 0) { domain = this.domain; }
        return new ServiceAgentRequest(type, url, params, domain, this);
    };
    /** 向服务区发送请求 */
    ServiceAgent.prototype.call = function (target, type, url, params, domain) {
        if (domain === void 0) { domain = this.domain; }
        return new ServiceAgentRequest(type, url, params, domain, this).end(target);
    };
    /** 创建并发送一个请求 (type === get) */
    ServiceAgent.prototype.get = function (url, params, domain) {
        if (domain === void 0) { domain = this.domain; }
        return this.create('get', url, params, domain);
    };
    /** 创建并发送一个请求 (type === post) */
    ServiceAgent.prototype.post = function (url, params, domain) {
        if (domain === void 0) { domain = this.domain; }
        return this.create('post', url, params, domain);
    };
    /** 创建并发送一个请求 (type === put) */
    ServiceAgent.prototype.put = function (url, params, domain) {
        if (domain === void 0) { domain = this.domain; }
        return this.create('put', url, params, domain);
    };
    /** 创建并发送一个请求 (type === del) */
    ServiceAgent.prototype.del = function (url, params, domain) {
        if (domain === void 0) { domain = this.domain; }
        return this.create('del', url, params, domain);
    };
    return ServiceAgent;
}());
export { ServiceAgent };
var ServiceAgentRequest = /** @class */ (function () {
    function ServiceAgentRequest(type, url, params, domain, serviceAgent) {
        var _this = this;
        /** 请求前函数组 */
        this._reqFs = [];
        /** 请求后函数组 */
        this._resFs = [];
        /** 设置 请求前函数组 */
        this.reqFs = function (value) {
            _this._reqFs = value || [];
            return _this;
        };
        /** 设置 请求后函数组 */
        this.resFs = function (value) {
            _this._resFs = value || [];
            return _this;
        };
        /** 设置 Headers  */
        this.set = function (option) {
            _this.superAgentRequest.set(option);
            return _this;
        };
        /** 设置返回数据的类型 */
        this.responseType = function (type) {
            _this.superAgentRequest.responseType(type);
            return _this;
        };
        /** 设置 Content-Type */
        this.accept = function (option) {
            _this.superAgentRequest.accept(option);
            return _this;
        };
        /** 设置接受类型 */
        this.type = function (option) {
            _this.superAgentRequest.type(option);
            return _this;
        };
        /** 中止请求 */
        this.abort = function () {
            _this.superAgentRequest.abort();
            return _this;
        };
        /**
         * 附加文件
         * @param field 服务区接受key
         * @param file 文件
         * @param filename 文件名
         */
        this.attach = function (field, file, filename) {
            _this.superAgentRequest.attach(field, file, filename);
            return _this;
        };
        /** 字段值 */
        this.field = function (name, val) {
            _this.superAgentRequest.field(name, val);
            return _this;
        };
        /** 发送请求 */
        this.end = function (target, fus) {
            if (target === void 0) { target = null; }
            var reqFs = _this._reqFs;
            var resFs = _this._resFs;
            var sar = _this.superAgentRequest;
            return _this.serviceAgent.send({ target: target, fus: fus, reqFs: reqFs, resFs: resFs, sar: sar });
        };
        /** 发送请求 */
        this.over = function (target, fus) {
            if (target === void 0) { target = null; }
            return new Promise(function (resolve, reject) {
                var reqFs = _this._reqFs;
                var resFs = _this._resFs;
                var sar = _this.superAgentRequest;
                _this.serviceAgent.send({ target: target, fus: fus, reqFs: reqFs, resFs: resFs, sar: sar }).then(function (api) {
                    if (api.err) {
                        reject(api.err);
                    }
                    else {
                        resolve(api.res);
                    }
                });
            });
        };
        /** 发送请求 */
        this.fulfil = function (target, fus) {
            if (target === void 0) { target = null; }
            return new Promise(function (resolve, reject) {
                var reqFs = _this._reqFs;
                var resFs = _this._resFs;
                var sar = _this.superAgentRequest;
                _this.serviceAgent.send({ target: target, fus: fus, reqFs: reqFs, resFs: resFs, sar: sar }).then(function (api) {
                    if (api.err) {
                        reject(new ServiceAgentError(api.err));
                    }
                    else {
                        resolve(api.res);
                    }
                });
            });
        };
        /** 发送的参数 get */
        this.query = function (val) {
            _this.superAgentRequest.query(val);
            return _this;
        };
        /** 监听事件 */
        this.on = function (name, handler) {
            _this.superAgentRequest.on(name, handler);
            return _this;
        };
        /** 发送的参数 post */
        this.send = function (val) {
            _this.superAgentRequest.send(val);
            return _this;
        };
        this.serviceAgent = serviceAgent;
        this._reqFs = serviceAgent.reqFs.slice();
        this._resFs = serviceAgent.resFs.slice();
        this.superAgentRequest = getSuperAgentRequest(type, url, params, domain);
    }
    return ServiceAgentRequest;
}());
export { ServiceAgentRequest };
/** 获取一个 SuperAgent 的请求对象 */
function getSuperAgentRequest(type, url, params, domain) {
    if (params) {
        return superagent[type]("" + domain + url)[type === 'get' ? 'query' : 'send'](params);
    }
    else {
        return superagent[type]("" + domain + url);
    }
}
/**
 * 异步请求 吧获取到的数据向下一级函数传递
 * @param request
 */
function request(req) {
    var sar = req.sar;
    return new Promise(function (resolve) {
        if (req.err) {
            if (req && req.sar && req.sar.abort) {
                req.sar.abort();
            }
            else if (req && req.err && req.err.sar && req.err.sar.abort) {
                req.err.sar.abort();
            }
            resolve({ err: req.err, sar: sar, res: null, target: req.target });
        }
        else {
            req.sar.end(function (err, res) {
                resolve({ err: err, res: res, sar: sar, target: req.target });
            });
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/grey-service-agent/index.js
// module id = 2441
// module chunks = 0